import { getContrastColor } from '@Utils/Formatters/constrastColor'
import { createHoverColor } from '@Utils/Formatters/hoverColor'
import { convertHexToRGBA } from '@Utils/Formatters/opacityColor'
import { auxiliaries } from './theme.utils'

export const lightTheme = {
    isDarkMode: false,
    body: '#F3F3F3',
    text: '#2E2D2C',
    toggleBorder: '#FFF',
    background: '#fff',
    sidebarColor: '#fff',
    headerColor: '#fff',
    borderColor: '#E4E4E4',
    colors: {
        primary: '#58BFD6',
        secondary: '#E83C78',
        tertiary: 'transparent',
        input: {
            background: '#fff',
            focusBorder: '#58BFD6',
            border: '#E4E4E4',
            label: createHoverColor(getContrastColor('#fff')),
            labelFocus: '#58BFD6',
            placeholder: '#595959',
            supportMessage: {
                error: '#E83C78',
                warning: '#DFA904',
                info: '#58BFD6',
                success: '#1F6C7C',
            },
        },
        button: {
            primaryHover: createHoverColor('#58BFD6'),
            primaryText: getContrastColor('#58BFD6'),
            secondaryHover: createHoverColor('#E83C78'),
            secondaryText: '#fff',
            tertiaryHover: createHoverColor('transparent'),
            tertiaryText: '#2E2D2C',
        },
        table: {
            inactiveRow: convertHexToRGBA('#E83C78', 0.1),
            oddRow: '#F3F3F3',
            hoverRow: '#EDF4F7',
            warningRow: '#DFA904',
            dangerRow: '#E83C78',
            successRow: '#1F6C7C',
        },
        container: {
            background: '#fff',
        },
    },
    ...auxiliaries,
}

export type ThemeType = typeof lightTheme
